if (!customElements.get('card-color-thumbnails')) {
  class CardColorThumbnails extends HTMLElement {
    constructor() {
      super();

      this.onResize = this.updateOverflow.bind(this);
      this.onScroll = this.updateOverflow.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('.card-color-thumbnails__viewport');
      this.track = this.querySelector('.card-color-thumbnails__track');
      this.previousArrow = this.querySelector(
      '.card-color-thumbnails__arrow--previous'
       );

      this.nextArrow = this.querySelector(
      '.card-color-thumbnails__arrow--next'
      );
      this.items = Array.from(
        this.querySelectorAll('.card-color-thumbnails__item')
      );
      this.card = this.closest('.card-wrapper');

      if (!this.viewport || !this.track || !this.card || !this.items.length) {
        this.hidden = true;
        return;
      }

      this.items.forEach((item) => {
        item.addEventListener('click', (event) => {
          this.selectColor(event, item);
        });
      });

     /* 每次点击箭头滚动的距离 */
const getScrollDistance = () =>
  Math.max(this.viewport.clientWidth * 0.75, 120);

/* 点击左箭头 */
if (this.previousArrow) {
  this.previousArrow.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.viewport.scrollBy({
      left: -getScrollDistance(),
      behavior: 'smooth'
    });
  });
}

/* 点击右箭头 */
if (this.nextArrow) {
  this.nextArrow.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.viewport.scrollBy({
      left: getScrollDistance(),
      behavior: 'smooth'
    });
  });
}

      this.viewport.addEventListener('scroll', this.onScroll, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateOverflow();
        });

        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      requestAnimationFrame(() => {
        this.updateOverflow();
      });
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      window.removeEventListener('resize', this.onResize);

      if (this.viewport) {
        this.viewport.removeEventListener('scroll', this.onScroll);
      }
    }

    selectColor(event, selectedItem) {
      event.preventDefault();
      event.stopPropagation();

      this.items.forEach((item) => {
        const selected = item === selectedItem;

        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      this.updateImages(selectedItem);
      this.updatePrice(selectedItem);
      this.updateLinks(selectedItem);
      this.updateAvailability(selectedItem);
    }

    updateImages(selectedItem) {
      const imageSrc = selectedItem.dataset.imageSrc;
      const imageSrcset = selectedItem.dataset.imageSrcset;
      const imageAlt = selectedItem.dataset.imageAlt || '';

      if (!imageSrc) return;

      const cardImages = this.card.querySelectorAll(
        '.card__media .media > img'
      );

      cardImages.forEach((image) => {
        image.src = imageSrc;

        if (imageSrcset) {
          image.srcset = imageSrcset;
        }

        image.alt = imageAlt;
      });
    }

    updatePrice(selectedItem) {
      const templateId = selectedItem.dataset.priceTemplate;

      if (!templateId) return;

      const priceTemplate = document.getElementById(templateId);
      const currentPrice = this.card.querySelector(
        '.card-information .price'
      );

      if (
        !priceTemplate ||
        !currentPrice ||
        !priceTemplate.content.firstElementChild
      ) {
        return;
      }

      const newPrice =
        priceTemplate.content.firstElementChild.cloneNode(true);

      currentPrice.replaceWith(newPrice);
    }

    updateLinks(selectedItem) {
      const variantUrl = selectedItem.dataset.variantUrl;

      if (!variantUrl) return;

      const productLinks = this.card.querySelectorAll(
        '.card__heading a, a.product__view-details'
      );

      productLinks.forEach((link) => {
        link.href = variantUrl;
      });

      const quickAddButtons = this.card.querySelectorAll(
        '[data-product-url]'
      );

      quickAddButtons.forEach((button) => {
        button.dataset.productUrl = variantUrl;
      });
    }

    updateAvailability(selectedItem) {
      const available = selectedItem.dataset.available === 'true';

      this.card.classList.toggle(
        'card--selected-color-sold-out',
        !available
      );

      this.card.dataset.selectedVariantId =
        selectedItem.dataset.variantId || '';

      this.card.dataset.selectedVariantAvailable = available
        ? 'true'
        : 'false';
    }

  updateOverflow() {
  if (
    !this.viewport ||
    !this.previousArrow ||
    !this.nextArrow
  ) {
    return;
  }

  const maximumScroll =
    this.viewport.scrollWidth - this.viewport.clientWidth;

  const hasOverflow = maximumScroll > 2;
  const reachedStart = this.viewport.scrollLeft <= 4;
  const reachedEnd =
    this.viewport.scrollLeft >= maximumScroll - 4;

  this.classList.toggle('has-overflow', hasOverflow);

  /* 缩略图没有超出时隐藏两个箭头 */
  if (!hasOverflow) {
    this.previousArrow.hidden = true;
    this.nextArrow.hidden = true;
    return;
  }

  /* 最左边隐藏左箭头，最右边隐藏右箭头 */
  this.previousArrow.hidden = reachedStart;
  this.nextArrow.hidden = reachedEnd;
}
  }

  customElements.define(
    'card-color-thumbnails',
    CardColorThumbnails
  );
}


